// Schwere einer Syslog-Zeile (RFC 5424, 6.2.1) mit Text und Statusfarbe.
// 0 bis 3 sind Fehler in abgestufter Dringlichkeit, 4 eine Warnung, darunter
// Auskunft.

export const SCHWEREN = ['Notfall', 'Alarm', 'Kritisch', 'Fehler', 'Warnung', 'Hinweis', 'Info', 'Debug'] as const

export function schwereText(severity: number): string {
  return SCHWEREN[severity] ?? String(severity)
}

export function schwereStufe(severity: number): 'crit' | 'warn' | 'info' | 'off' {
  if (severity <= 3) return 'crit'
  if (severity === 4) return 'warn'
  if (severity === 5) return 'info'
  return 'off'
}

/** Die Stufen der Aufbewahrung, wie die Zentrale sie annimmt. */
export const AUFBEWAHRUNG = [0, 7, 30, 90, 180, 365] as const

export function aufbewahrungText(tage: number): string {
  return tage === 0 ? 'nicht speichern' : `${tage} Tage`
}
